import { render } from "./send_success.vue?vue&type=template&id=3a2893dc&scoped=true"
import script from "./send_success.vue?vue&type=script&lang=js"
export * from "./send_success.vue?vue&type=script&lang=js"

import "./send_success.vue?vue&type=style&index=0&id=3a2893dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2893dc"]])

export default __exports__